import { useState } from 'preact/hooks';
import { api, ApiError } from '../../lib/api.js';
import { toInputValue, fromInputValue } from './shifts-shared.js';

// Self-service fix for a forgotten clock-in — the caller's own open shift
// only, no admin involved. Deliberately separate from CorrectShiftModal:
// that's an admin override (stamps corrected_by/corrected_at); this is
// normal use, same trust level as clocking in itself.
export const ClockInEditor = ({ clockInAt, onSaved }) => {
  const [editing, setEditing] = useState(false);
  const [value, setValue] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const start = () => {
    setValue(toInputValue(clockInAt));
    setError(null);
    setEditing(true);
  };

  const save = async () => {
    setBusy(true); setError(null);
    try {
      const updated = await api.patch('/shifts/clock-in', { clockInAt: fromInputValue(value) });
      setEditing(false);
      onSaved?.(updated);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Failed');
    } finally {
      setBusy(false);
    }
  };

  if (!editing) {
    return (
      <button type="button" onClick={start} class="text-[11px] text-text-tertiary hover:text-brand">
        Fix time
      </button>
    );
  }

  return (
    <div class="flex flex-wrap items-center gap-1.5">
      <input
        type="datetime-local"
        value={value}
        onInput={(e) => setValue(e.currentTarget.value)}
        class="rounded-md border border-border-strong bg-bg-base px-1.5 py-0.5 text-[11px] text-text-primary focus:border-brand focus:outline-none focus:ring-1 focus:ring-brand"
      />
      <button type="button" onClick={save} disabled={busy || !value} class="text-[11px] font-semibold text-brand disabled:opacity-50">
        {busy ? '…' : 'Save'}
      </button>
      <button type="button" onClick={() => setEditing(false)} disabled={busy} class="text-[11px] text-text-tertiary">
        Cancel
      </button>
      {error && <span class="text-[11px] font-semibold text-ink-magenta">{error}</span>}
    </div>
  );
};
